import src from "IMAGE";
export default { src, width: 236, height: 60, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAKklEQVR42nXDwQkAIAwDwG6gv+CkfowQsng7QHtwscoeADhB8kp6Xds/AWxAEgqJEWUYAAAAAElFTkSuQmCC"};
